/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplatesControllerFindAllQueryResponse, WorkflowTemplatesControllerFindAllQueryParams, WorkflowTemplatesControllerFindAll401, WorkflowTemplatesControllerFindAll403 } from "../../models/workflowsController/WorkflowTemplatesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { workflowTemplatesControllerFindAll } from "../../clients/workflowsService/workflowTemplatesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const workflowTemplatesControllerFindAllQueryKey = (params: WorkflowTemplatesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/workflow-templates'
}, ...(params ? [params] : [])] as const;
export type WorkflowTemplatesControllerFindAllQueryKey = ReturnType<typeof workflowTemplatesControllerFindAllQueryKey>;
export function workflowTemplatesControllerFindAllQueryOptions(params?: WorkflowTemplatesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = workflowTemplatesControllerFindAllQueryKey(params);
  return queryOptions<WorkflowTemplatesControllerFindAllQueryResponse, ResponseErrorConfig<WorkflowTemplatesControllerFindAll401 | WorkflowTemplatesControllerFindAll403>, WorkflowTemplatesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return workflowTemplatesControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List workflow templates (scope-filtered)
 * {@link /api/v1/workflow-templates}
 */
export function useWorkflowTemplatesControllerFindAll<TData = WorkflowTemplatesControllerFindAllQueryResponse, TQueryData = WorkflowTemplatesControllerFindAllQueryResponse, TQueryKey extends QueryKey = WorkflowTemplatesControllerFindAllQueryKey>(params?: WorkflowTemplatesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<WorkflowTemplatesControllerFindAllQueryResponse, ResponseErrorConfig<WorkflowTemplatesControllerFindAll401 | WorkflowTemplatesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? workflowTemplatesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...workflowTemplatesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WorkflowTemplatesControllerFindAll401 | WorkflowTemplatesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}